<template>
    <div class="jygm-jthnt-diagram">
        <div class="bg-img-wrap">
            <div class="total-wrap" id="main" ref="main">
                <div
                    id="canvas"
                    ref="canvas"
                    class="canvas-wrap"
                    :style="
                        `transform: scale(${scale});width:${width};height:${height};top:${top}px;left:${left}px`
                    "
                >
                    <img class="bg-img" src="../../../assets/image/diagram/9-06.png" alt srcset />
                    <div
                        v-for="(item, index) in datas"
                        :key="item.point_id"
                        class="bian-switch"
                        :style="`top:${item._top + 25}%;left:${item._left}%;`"
                    >
                        <template v-if="index == 0">
                            <template v-if="item.isOn == 1">
                                <img
                                    src="../../../assets/image/diagram/b9.png"
                                    alt
                                    srcset
                                    class="kaiguan2"
                                />
                            </template>
                            <template v-else>
                                <img
                                    src="../../../assets/image/diagram/b3.png"
                                    alt
                                    srcset
                                    class="kaiguan2"
                                />
                            </template>
                        </template>
                    </div>
                    <div
                        v-for="item in datas"
                        :key="item.point_id"
                        class="top-switch"
                        :style="`top:${item._top}%;left:${item._left}%;`"
                    >
                        <template v-if="item.isOn == 1">
                            <img
                                v-if="item.another == 0"
                                src="../../../assets/image/diagram/guan-new.png"
                                alt
                                srcset
                                class="kaiguan"
                            />
                            <img
                                v-else
                                src="../../../assets/image/diagram/guan-new3.png"
                                alt
                                srcset
                                class="kaiguan"
                            />
                        </template>
                        <template v-else>
                            <img
                                v-if="item.another == 0"
                                src="../../../assets/image/diagram/kai-new.png"
                                alt
                                srcset
                                class="kaiguan"
                            />
                            <img
                                v-else
                                src="../../../assets/image/diagram/kai-new3.png"
                                alt
                                srcset
                                class="kaiguan"
                            />
                        </template>
                        <!-- <template v-else>
                            <img
                                src="../../../../assets/image/diagram/error.png"
                                alt
                                srcset
                                class="kaiguan"
                            />
                        </template>-->
                    </div>
                    <div
                        v-for="item in datas"
                        :key="item.point_id"
                        class="data-wrap"
                        :style="`top:${item.top};left:${item.left};`"
                        @click="showdialog(item)"
                    >
                        <template>
                            <div class="data-item">
                                <div class="data-name yellow">电压</div>
                                <div class="data-number diagram-input-bg">
                                    {{ item.ia }}
                                    <span>kV</span>
                                </div>
                            </div>
                            <div class="data-item">
                                <div class="data-name yellow">总有功功率</div>
                                <div class="data-number diagram-input-bg">
                                    {{ item.ib }}
                                    <span>kW</span>
                                </div>
                            </div>
                            <div class="data-item">
                                <div class="data-name yellow">功率因数</div>
                                <div class="data-number diagram-input-bg">
                                    {{ item.ic }}
                                    <span></span>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <ElecDialog :dialogVisible.sync="dialogVisible" :id="data_id" />
    </div>
</template>
<script>
import * as api from "@/http/http-60.js";
import ElecDialog from "../index-yn/components/elec-diagram-dialog.vue"
export default {
    components: {
        ElecDialog
    },
    data() {
        return {
            diagramType: 1,
            left: "0",
            top: "0",
            scale: 0.9,
            basisUnitV: 1,
            basisUnitH: 1,
            scaleIcon: 0.5,
            dialogVisible: false,
            data_id: "",
            dialogTitle: "",
            datas: [
                {
                    point_id: "1484397471001137152",
                    name: "总进线", //主线名称
                    // 开关
                    _top: 22,
                    _left: 1.8,
                    another: 1, // 是否是第二种开关 默认0
                    isOn: -1,  //1默认连通  红色；  0断开  绿色
                    // 数据
                    top: "26%",
                    left: "5%",
                    ia: "0",
                    ib: "0",
                    ic: "0",
                },
                {
                    point_id: "1484395206022451200",
                    name: "1号线", //主线名称
                    // 开关
                    _top: 22,
                    _left: 21.9,
                    another: 0, // 是否是第二种开关 默认0
                    isOn: -1,  //1默认连通  红色；  0断开  绿色
                    // 数据
                    top: "26%",
                    left: "25%",
                    ia: "0",
                    ib: "0",
                    ic: "0",
                },
                {
                    point_id: "1484395808156733440",
                    name: "2号线", //主线名称
                    // 开关
                    _top: 22,
                    _left: 52.15,
                    another: 0, // 是否是第二种开关 默认0
                    isOn: -1,  //1默认连通  红色；  0断开  绿色
                    // 数据
                    top: "26%",
                    left: "55%",
                    ia: "0",
                    ib: "0",
                    ic: "0",
                },
                {
                    point_id: "1484396589790449664",
                    name: "照明电源", //主线名称
                    // 开关
                    _top: 22,
                    _left: 72.25,
                    another: 0, // 是否是第二种开关 默认0
                    isOn: -1,  //1默认连通  红色；  0断开  绿色
                    // 数据
                    top: "90%",
                    left: "69%",
                    ia: "0",
                    ib: "0",
                    ic: "0",
                },
                {
                    point_id: "1491723565836455936",
                    name: "10kv进线", //主线名称
                    // 开关
                    _top: -10000000,
                    _left: -1000000,
                    another: 0, // 是否是第二种开关 默认0
                    isOn: -1,  //1默认连通  红色；  0断开  绿色
                    // 数据
                    top: "90%",
                    left: "-2%",
                    ia: "0",
                    ib: "0",
                    ic: "0",
                },
                {
                    point_id: "1484401188488269824",
                    name: "#1搅拌", //主线名称
                    // 开关
                    _top: 52.5,
                    _left: 11.9,
                    another: 0, // 是否是第二种开关 默认0
                    isOn: -1,  //1默认连通  红色；  0断开  绿色
                    // 数据
                    top: "90%",
                    left: "8%",
                    ia: "0",
                    ib: "0",
                    ic: "0",
                },
                {
                    point_id: "1484401425546137600",
                    name: "#2搅拌", //主线名称
                    // 开关
                    _top: 52.5,
                    _left: 21.9,
                    another: 0, // 是否是第二种开关 默认0
                    isOn: -1,  //1默认连通  红色；  0断开  绿色
                    // 数据
                    top: "90%",
                    left: "18%",
                    ia: "0",
                    ib: "0",
                    ic: "0",
                },
                {
                    point_id: "1484401814731411456",
                    name: "斜面传送", //主线名称
                    // 开关
                    _top: 52.5,
                    _left: 32,
                    another: 0, // 是否是第二种开关 默认0
                    isOn: -1,  //1默认连通  红色；  0断开  绿色
                    // 数据
                    top: "90%",
                    left: "28%",
                    ia: "0",
                    ib: "0",
                    ic: "0",
                },
                {
                    point_id: "1484402536487243776",
                    name: "#1搅拌", //主线名称
                    // 开关
                    _top: 52.5,
                    _left: 42.05,
                    another: 0, // 是否是第二种开关 默认0
                    isOn: -1,  //1默认连通  红色；  0断开  绿色
                    // 数据
                    top: "90%",
                    left: "39%",
                    ia: "0",
                    ib: "0",
                    ic: "0",
                },
                {
                    point_id: "1484402790456545280",
                    name: "#2搅拌", //主线名称
                    // 开关
                    _top: 52.5,
                    _left: 52.15,
                    another: 0, // 是否是第二种开关 默认0
                    isOn: -1,  //1默认连通  红色；  0断开  绿色
                    // 数据
                    top: "90%",
                    left: "49%",
                    ia: "0",
                    ib: "0",
                    ic: "0",
                },
                {
                    point_id: "1484403139665907712",
                    name: "斜皮带", //主线名称
                    // 开关
                    _top: 52.5,
                    _left: 62.2,
                    another: 0, // 是否是第二种开关 默认0
                    isOn: -1,  //1默认连通  红色；  0断开  绿色
                    // 数据
                    top: "90%",
                    left: "59%",
                    ia: "0",
                    ib: "0",
                    ic: "0",
                },
            ],
            timer: null,
        };
    },
    mounted() {
        this.zoom();
        this.drag();
        this.getData();
        this.setTimer();
        this.setImgSize();
        window.onresize = () => {
            this.setImgSize();
        };
    },
    methods: {
        setImgSize() {
            if (window.innerWidth >= 2560) {
                this.basisUnitH = 1.2;
                this.basisUnitV = 1.2;
            } else if (window.innerWidth < 2560 && window.innerWidth >= 1900) {
                this.basisUnitH = 1.0;
                this.basisUnitV = 0.82;
            } else if (window.innerWidth < 1920 && window.innerWidth >= 1660) {
                this.basisUnitH = 0.82;
                this.basisUnitV = 0.82;
            } else if (window.innerWidth < 1660 && window.innerWidth >= 1420) {
                this.basisUnitH = 0.7;
                this.basisUnitV = 0.7;
            } else if (window.innerWidth < 1420 && window.innerWidth >= 1320) {
                this.basisUnitH = 0.6;
                this.basisUnitV = 0.6;
            } else {
            }
        },
        setTimer() {
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(() => {
                this.getData();
            }, 10000);
        },
        getData() {
            let pointIds = [];
            this.datas.forEach(item => {
                pointIds.push(item.point_id);
            });
            api.getDataAll(pointIds).then(res => {
                let valueJson = res.bus_json;
                this.datas.forEach(item => {
                    // 1491723565836455936
                    console.log("ue: ", item);
                    if (item.point_id == "1491723565836455936") {
                        let point = valueJson[item.point_id];
                        // 电压（平均）
                        let tempV = (parseFloat(point && point.v_a) + parseFloat(point && point.v_c)) / 2;
                        item.ia = tempV.toFixed(2);

                        let IB = parseFloat(point && point.a_a) * parseFloat(point && point.a_a) + parseFloat(point && point.a_c) * parseFloat(point && point.a_c) - parseFloat(point && point.a_c) * parseFloat(point && point.a_a);
                        let sqrtIB = Math.sqrt(IB);
                        let PB = tempV * sqrtIB * 0.95;

                        let tempP = (parseFloat(point && point.p_a) + PB + parseFloat(point && point.p_c));
                        item.ib = tempP.toFixed(2);

                        // 功率因数（平均）
                        let tempPf = (parseFloat(point && point.pf_a) + parseFloat(point && point.pf_b) + parseFloat(point && point.pf_c)) / 3;
                        item.ic = tempPf.toFixed(2);
                    } else {
                        let point = valueJson[item.point_id];
                        // 电压（平均）
                        let tempV = (parseFloat(point && point.v_a) + parseFloat(point && point.v_b) + parseFloat(point && point.v_c)) / 3;
                        item.ia = tempV.toFixed(2);
                        // 总有功功率(求和) 除1000变kw
                        let tempP = (parseFloat(point && point.p_a) + parseFloat(point && point.p_b) + parseFloat(point && point.p_c));
                        item.ib = tempP.toFixed(2);
                        // 功率因数（平均）
                        let tempPf = (parseFloat(point && point.pf_a) + parseFloat(point && point.pf_b) + parseFloat(point && point.pf_c)) / 3;
                        item.ic = tempPf.toFixed(2);
                        // A相电压有数据时，isOn为1 否则为0
                        // if (point && point.is_offline) {
                        item.isOn = point.is_offline == 1 ? 0 : 1
                    }

                });
            });
        },
        showdialog(item) {
            this.dialogVisible = true;
            this.data_id = item.point_id;
        },
        zoom() {
            let vm = this;
            if (navigator.userAgent.indexOf("Firefox") != -1) {
                //FF
                document.getElementById("main").addEventListener(
                    "DOMMouseScroll",
                    function (event) {
                        event = event || window.event;
                        if (event.detail > 0) {
                            vm.scale =
                                vm.scale > 0.2 ? vm.scale - 0.1 : vm.scale;
                        } else {
                            vm.scale += 0.1;
                        }
                        event.cancelBubble = true;
                        event.stopPropagation();
                        event.preventDefault();
                    },
                    false
                );
            } else {
                //非FF
                document.getElementById("main").onmousewheel = function (event) {
                    event = event || window.event;
                    if (event.deltaY > 0) {
                        vm.scale = vm.scale > 0.2 ? vm.scale - 0.1 : vm.scale;
                    } else {
                        vm.scale += 0.1;
                    }
                    event.cancelBubble = true;
                    event.stopPropagation();
                    event.preventDefault();
                };
            }
        },
        drag() {
            let oDiv = this.$refs.canvas;
            let vm = this;
            oDiv.onmousedown = function (en) {
                let ev = ev || event;
                let disX = en.clientX - oDiv.offsetLeft;
                let disY = en.clientY - oDiv.offsetTop;
                oDiv.onmousemove = function (en) {
                    let ev = ev || event;
                    if (
                        en.clientY > 0 &&
                        en.clientY < vm.$refs.main.clientHeight &&
                        en.clientX > 0 &&
                        en.clientX < vm.$refs.main.clientWidth
                    ) {
                        vm.top = en.clientY - disY;
                        vm.left = en.clientX - disX;
                    }
                };
                oDiv.onmouseup = function () {
                    oDiv.onmousemove = null;
                };
                return false;
            };
        }
    },
    destroyed() {
        clearInterval(this.timer);
    }
};
</script>
<style lang="scss" scoped>
.jygm-jthnt-diagram {
    width: 100%;
    height: 100%;
    color: #fff;
    padding: 0 2rem 0rem 2rem;
    padding-top: 0;
    box-sizing: border-box;
    position: relative;

    h2 {
        color: #fff;
        line-height: 1.8rem;
        text-indent: 2.5rem;
        font-size: 16px;
        float: left;
    }

    .bg-img-wrap {
        margin: 0 auto;
        text-align: center;
        align-self: center;
        width: 100%;
        height: 100%;
        position: relative;

        .kaiguan {
            width: 4rem;
            height: auto;
        }
        .kaiguan2 {
            width: 4.5rem;
            height: auto;
        }
        .kaiguan1 {
            width: 7.5rem;
            height: auto;
        }
        .update-time {
            position: absolute;
            top: -1%;
            left: 11%;
            font-size: 0.8rem;
            color: #fff;
        }
        .total-wrap {
            top: 0%;
            left: 0%;
            width: 100%;
            padding: 2rem 2rem 0 2rem;
            box-sizing: border-box;
            height: 100%;
            position: relative;
            overflow: hidden;
            cursor: move;

            .canvas-wrap {
                width: 100%;
                // min-height: 100%;
                // height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                box-sizing: border-box;

                .bg-img {
                    width: 100%;
                    height: 100%;
                }
            }
            .bian-switch {
                // cursor: pointer;
                transform: scale(0.5);
                position: absolute;
                text-align: center;
                display: flex;
                // height: 20%;
                overflow: hidden;
            }
            .top-switch {
                // cursor: pointer;
                transform: scale(0.4);
                position: absolute;
                text-align: center;
                display: flex;
                height: 20%;
                overflow: hidden;

                .top-title {
                    align-self: center;
                    margin-left: 0.7rem;
                    font-size: 0.8rem;
                }
            }

            .bottom-switch {
                // cursor: pointer;
                transform: scale(1);
                position: absolute;
                text-align: center;
                display: flex;
                height: 20%;
                overflow: hidden;

                .bottom-title {
                    align-self: center;
                    margin-left: 0.7rem;
                    font-size: 0.8rem;
                }
            }

            .data-wrap {
                position: absolute;
                display: grid;
                transform: scale(0.85);

                .data-item {
                    display: flex;
                    margin-bottom: 0.1rem;

                    .data-name {
                        align-self: center;
                        font-size: 0.8rem;
                        margin-right: 0.1rem;
                        width: 4rem;
                        text-align: right;
                        font-weight: bold;
                    }

                    .data-number {
                        font-size: 0.8rem;
                        width: 4.8rem;
                        text-align: right;
                        // background-color: #114aa5;
                        color: #fff;
                        height: 1.2rem;
                        line-height: 1.2rem;

                        nowrap span {
                            display: inline-block;
                            margin-left: 0.2rem;
                            margin-right: 0.2rem;
                        }
                    }

                    .data-u {
                        height: 1.1rem;
                        line-height: 1.1rem;
                    }

                    .data-name-u {
                        font-size: 0.9rem;
                        margin-right: 1rem;
                    }
                }
            }
        }
    }
    .red {
        color: #fe0101;
    }

    .yellow {
        color: #fefa00;
    }

    .green {
        color: #00b200;
    }
}
</style>
